import { useState } from "react";
import { Box, Grid, Link, Typography } from "@mui/material";
import { FooterStyles } from "./styles/Footer.styles";
import GA from "src/analytics/googleAnalytics";
import ExternalLinkWarning from "./ExternalLinkWarning";
import { trackEvent } from "src/Amplitude";

// functional component
export default function Footer(props: { externalFooter?: boolean }) {
  const classes = FooterStyles();

  //const { clientDetails } = useContext(appContext);
  const instagramUrl = "https://www.instagram.com/calebandbrown/?hl=en";
  const linkedInUrl = "https://www.linkedin.com/company/calebandbrown/";
  const facebookUrl = "https://www.facebook.com/calebandbrown";
  const twitterUrl = "https://twitter.com/calebandbrown?lang=en";
  const termsOfUseUrl = "https://www.calebandbrown.com/website-terms-of-use";
  const privacyPolicyUrl = "https://www.calebandbrown.com/privacy-policy";
  const termsOfBusinessUrl = "https://www.calebandbrown.com/terms-of-business";
  const blogUrl = "https://www.calebandbrown.com/blog?utm_source=cnc-portal";
  const complaintForm = "https://form.asana.com/?k=grtl60BFDkt2fLC3BMPG9Q&d=538008531828845";

  //Warnings
  const [selectedUrl, setSelectedUrl] = useState("");
  const [externalWarning, setExternalWarning] = useState(false);

  const handleGoogleAnalytics = (social: string) => {
    GA.socialMedia(social);
    trackEvent(`User_Clicked_On_External_Link`, { social }, "Footer");
    setExternalWarning(true);
    switch (social) {
      case "Twitter":
        setSelectedUrl(twitterUrl);
        break;
      case "Facebook":
        setSelectedUrl(facebookUrl);
        break;
      case "LinkedIn":
        setSelectedUrl(linkedInUrl);
        break;
      case "Instagram":
        setSelectedUrl(instagramUrl);
        break;
      default:
        console.warn(`Could not navigate to ${social}`);
    }
  };

  const handleExternalNavigation = (link: string) => {
    trackEvent(`User_Opens_External_Url`, { link }, "Footer");
    setExternalWarning(true);
    switch (link) {
      case "termsOfUse":
        setSelectedUrl(termsOfUseUrl);
        break;
      case "privacyPolicy":
        setSelectedUrl(privacyPolicyUrl);
        break;
      case "termsOfBusiness":
        setSelectedUrl(termsOfBusinessUrl);
        break;
      case "blog":
        setSelectedUrl(blogUrl);
        break;
      case "complaintForm":
        setSelectedUrl(complaintForm);
        break;
      default:
        console.warn(`Could not navigate to ${link}`);
    }
  };

  const setUserSelectionCallBack = (permission: string) => {
    if (permission === "Confirm") return window.open(selectedUrl, "_blank");
  };

  const Divider = (props: { noVerticalLine?: boolean }) => {
    const { noVerticalLine } = props;
    return noVerticalLine ? (
      <Typography className={classes.subtitle} mx={1}>
        {" "}
      </Typography>
    ) : (
      <Typography className={classes.subtitle} mx={1}>
        {" | "}
      </Typography>
    );
  };

  // Same approach as OnClickWrapper in BrokerHumanisation
  const callNumber = (number: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = "tel:" + number;
  };

  return (
    <>
      <ExternalLinkWarning
        option={externalWarning}
        setExternalWarning={setExternalWarning}
        handleSelection={setUserSelectionCallBack}
        selectedUrl={selectedUrl}
      />
      <Box className={props.externalFooter ? classes.externalFooter : classes.footer}>
        <Grid container spacing={4} pt={1}>
          <Grid item xs={9} sm={6} md={8} className={classes.typography}>
            <Box className={classes.boxAddress}>
              <Link href="tel:+12133765432" color="inherit" underline="none" onClick={callNumber("+12133765432")}>
                {"+1 (213) 376 5432 (INTL)"}
              </Link>
              <Typography className={classes.typography}>
                <Link href="tel:+611800849149" color="inherit" underline="none" onClick={callNumber("+611800849149")}>
                  {"+61 1800 849 149 (AUS/INTL)"}
                </Link>
              </Typography>
              <Typography className={classes.typography}>2-6 Gwynne St,</Typography>
              <Typography className={classes.typography}>Cremorne VIC 3121, Australia</Typography>
            </Box>
          </Grid>
          <Grid item container md={4} xs={2} sm={4}>
            <Grid item xs={4} sm={8} md={4}>
              <Box className={classes.boxsocial}>
                <Link
                  className={classes.link}
                  onClick={() => handleGoogleAnalytics("Twitter")}
                  color="inherit"
                  underline="none">
                  {"Twitter"}
                </Link>
                <Typography>
                  <Link
                    className={classes.link}
                    onClick={() => handleGoogleAnalytics("LinkedIn")}
                    color="inherit"
                    underline="none">
                    {"LinkedIn"}
                  </Link>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <Box className={classes.boxsocial}>
                <Link
                  className={classes.link}
                  onClick={() => handleGoogleAnalytics("Instagram")}
                  color="inherit"
                  underline="none">
                  {"Instagram"}
                </Link>
                <Typography>
                  <Link
                    className={classes.link}
                    onClick={() => handleGoogleAnalytics("Facebook")}
                    color="inherit"
                    underline="none">
                    {"Facebook"}
                  </Link>
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8} md={12}>
            <Box className={classes.boxfooterEnd}>
              <Typography className={classes.subtitle}>
                {" © Copyright • Caleb & Brown "}
              </Typography>
              <Divider noVerticalLine />
              <Link
                className={`${classes.subtitle} ${classes.link}`}
                onClick={() => handleExternalNavigation("termsOfUse")}
                underline="none">
                {"Website Terms of Use"}
              </Link>
              <Divider />
              <Link
                className={`${classes.subtitle} ${classes.link}`}
                onClick={() => handleExternalNavigation("privacyPolicy")}
                underline="none">
                {"Privacy Policy"}
              </Link>
              <Divider />
              <Link
                className={`${classes.subtitle} ${classes.link}`}
                onClick={() => handleExternalNavigation("termsOfBusiness")}
                underline="none">
                {"Terms of Business"}
              </Link>
              <Divider />
              <Link
                className={`${classes.subtitle} ${classes.link}`}
                onClick={() => handleExternalNavigation("blog")}
                underline="none">
                {"Blog"}
              </Link>
              <Divider />
              <Link
                className={`${classes.subtitle} ${classes.link}`}
                onClick={() => handleExternalNavigation("complaintForm")}
                underline="none">
                {"Submit a Complaint"}
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
